import { render, staticRenderFns } from "./LicenseManageFold.vue?vue&type=template&id=2ac0df3c&scoped=true&"
import script from "./LicenseManageFold.vue?vue&type=script&lang=js&"
export * from "./LicenseManageFold.vue?vue&type=script&lang=js&"
import style0 from "./LicenseManageFold.vue?vue&type=style&index=0&id=2ac0df3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0df3c",
  null
  
)

export default component.exports